import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

type PageMetaProps = {
  children?: React.ReactNode;
  title?: string;
  desktopTabIcon?: string | null;
};

const PageMeta = ({ children, title, desktopTabIcon }: PageMetaProps) => {
  useEffect(() => {
    if (desktopTabIcon) {
      window.desktop?.setDesktopTabIcon?.(desktopTabIcon);
    }
    return () => {
      window.desktop?.setDesktopTabIcon?.('');
    };
  }, [desktopTabIcon]);

  return (
    <Helmet defer={false}>
      {title && <title>{title}</title>}
      {children}
    </Helmet>
  );
};

export default PageMeta;
